export type IndustryItem = {slug: string; displayName: string};
export type CapabilityItem = {slug: string; displayName: string};
export type ProductItem = {slug: string; displayName: string; href: string};
export type AddressItem = {flagSrc: string; flagAlt: string; location: string; address: string; phone: string};
export type SocialItem = {href: string; src: string; alt: string};
export type SimpleLink = {href: string; text: string};

/* Sourced verbatim from growthjockey--website/app/utilities/server.tsx
 * getAllIndustries(), these slugs are the canonical GJ URL paths
 * (https://www.growthjockey.com/industries/<slug>), so any rename needs
 * to land in the GJ source first. Display-name ↔ slug mapping is NOT
 * intuitive (e.g. "Tech & Media" → "media-and-entertainment"). */
export const industries: Array<IndustryItem> = [
    {slug: "education", displayName: "Education & Edtech"},
    {slug: "banking-and-fintech", displayName: "Financial Services"},
    {slug: "travel-and-hospitality", displayName: "Travel & Hospitality"},
    {slug: "media-and-entertainment", displayName: "Tech & Media"},
    {slug: "energy", displayName: "Energy & Sustainability"},
    {slug: "real-estate", displayName: "Real Estate & Infrastructure"},
    {slug: "ev-and-automobile", displayName: "Automobile"},
    {slug: "ecommerce", displayName: "Digital Commerce & Marketplaces"},
    {slug: "software-and-platform", displayName: "Software and Platform"},
    {slug: "smart-retail", displayName: "Smart Retail"},
];

/* Sourced verbatim from getAllCapabilities() in the GJ source. NOTE: GJ's
 * source has a known typo, "Go to market" reuses slug "demand-generation"
 * (the same slug "Demand generation" uses). Both menu items therefore land
 * on the same GJ page. Keeping the duplicate to match GJ exactly; if/when
 * GJ fixes it, mirror the change here. */
export const capabilities: Array<CapabilityItem> = [
    {slug: "marketplace-building", displayName: "Marketplace Building"},
    {slug: "digital-marketing", displayName: "360° digital marketing"},
    {slug: "smo-and-orm", displayName: "SMO and ORM"},
    {slug: "ai-and-ml", displayName: "AI/ML"},
    {slug: "social-media-marketing", displayName: "Social media marketing"},
    {slug: "revenue-growth", displayName: "Revenue growth"},
    {slug: "operating-models", displayName: "Operating models"},
    {slug: "digital-transformation", displayName: "Digital Transformation"},
    {slug: "brand-growth", displayName: "Brand growth"},
    {slug: "marketing-automation", displayName: "Marketing automation"},
    {slug: "remote-business-operations", displayName: "Remote business operations"},
    {slug: "metaverse", displayName: "Metaverse"},
    {slug: "organic-growth", displayName: "Organic growth"},
    {slug: "consumer-lifecycle", displayName: "Consumer lifecycle"},
    {slug: "data-analytics", displayName: "Data analytics"},
    {slug: "profit-and-loss-operations", displayName: "Profit and loss operations"},
    {slug: "demand-generation", displayName: "Demand generation"},
    {slug: "demand-generation", displayName: "Go to market"},
    {slug: "ui-and-ux", displayName: "UI/UX"},
    {slug: "cloud-and-cyber-security", displayName: "Cloud and cyber security"},
];

/* Direct port from getAllProducts */
export const products: Array<ProductItem> = [
    {slug: "intellsys-adgpt", displayName: "Intellsys AdGPT", href: "/products/intellsys-adgpt"},
    {slug: "ottopilot", displayName: "OttoPilot", href: "/products/ottopilot"},
];

/* Direct port from getAllStaticNavLinks, order matters */
export const staticNavLinks: Array<SimpleLink> = [
    {href: "https://www.growthjockey.com/blogs", text: "Growth Blogs"},
    {href: "https://www.growthjockey.com/careers", text: "Careers"},
    {href: "/who-we-are", text: "Who We Are"},
    {href: "/what-we-do", text: "What We Do"},
];

/* Direct port from getAllAddresses, 3 offices, same phone for all */
export const addresses: Array<AddressItem> = [
    {
        flagSrc: "https://growthjockey-prod.b-cdn.net/new/flagIndia.webp",
        flagAlt: "India Flag",
        location: "Gurugram, India",
        address: "10th Floor, Tower A, Signature Towers, Opposite Hotel Crowne Plaza, South City I, Sector 30, Gurugram, Haryana 122001",
        phone: "+91 7018000000 ",
    },
    {
        flagSrc: "https://growthjockey-prod.b-cdn.net/new/flagUsa.webp",
        flagAlt: "USA Flag",
        location: "Irvine, United States of America",
        address: "19 Graham Street, Irvine, CA – 92617 , US",
        phone: "+91 7018000000 ",
    },
    {
        flagSrc: "https://growthjockey-prod.b-cdn.net/new/flagIndia.webp",
        flagAlt: "India Flag",
        location: "Guwahati, India",
        address: "Shreeji Tower, 3rd Floor, Guwahati, Assam, 781005",
        phone: "+91 7018000000 ",
    },
];

/* Direct port from getAllSocialLinks, 6 icons, order: YouTube · Facebook · Instagram · LinkedIn · Email · X */
export const socialLinks: Array<SocialItem> = [
    {href: "https://www.youtube.com/@growth_jockey", src: "https://growthjockey-prod.b-cdn.net/new/YT.svg", alt: "YouTube-icon"},
    {href: "https://www.facebook.com/GrowthJockey", src: "https://growthjockey-prod.b-cdn.net/new/Facebook.svg", alt: "Facebook-icon"},
    {href: "https://www.instagram.com/growth_jockey", src: "https://growthjockey-prod.b-cdn.net/new/Instagram.svg", alt: "Instagram-icon"},
    {href: "https://www.linkedin.com/company/growthjockey/", src: "https://growthjockey-prod.b-cdn.net/new/LinkedIn.svg", alt: "LinkedIn-icon"},
    {href: "mailto:team@growthjockey.com", src: "https://growthjockey-prod.b-cdn.net/new/mail.svg", alt: "Email-icon"},
    {href: "https://twitter.com/GrowthJockey", src: "https://growthjockey-prod.b-cdn.net/new/X.svg", alt: "X-icon"},
];

/* Direct port from getAllLegalLinks */
export const legalLinks: Array<SimpleLink> = [
    {href: "/privacy-policy", text: "Privacy Policy"},
    {href: "/terms-of-service", text: "Terms of Service"},
    {href: "/cookies-policy", text: "Cookie Policy"},
];
